
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Emit, Prop, Watch, Vue} from "vue-property-decorator";
import Opt from "@/ts/Opt";
import {SizeEnum} from "@/ts/Enum";

@Component
export default class SignalSourceItem extends Vue {
    @Prop() private opt: Opt;
    @Prop({default: SizeEnum.medium}) size: SizeEnum;

    // @Emit()
    activeClick() {
        if (this.opt.disable) {
            return;
        }
        this.$emit('activeClick', this.opt.key)
    }
}
